import Head from "next/head";

import LandingLayout from "../../Layouts/Navbar/LandingLayout/LandingLayout";
import Features from "./Features";
import Hero from "./Hero";

const Home = () => {
  return (
    <LandingLayout>
      <Head>
        <title>WinShopCRM</title>
      </Head>
      <>
        <Hero />
        <Features />
      </>
    </LandingLayout>
  );
};

export default Home;
